import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiEnvelope, LoginRequest, LoginResponse } from '../../models/auth.dto';

const SESSION_KEY = 'cbdx_session';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private apiUrl = environment.cbdx_service.api_path;
  private sessionSubject = new BehaviorSubject<LoginResponse | null>(this.getSession());
  public session$ = this.sessionSubject.asObservable();

  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<ApiEnvelope<LoginResponse>> {
    const body: LoginRequest = { email, password };
    return this.http.post<ApiEnvelope<LoginResponse>>(`${this.apiUrl}/auth/login`, body).pipe(
      tap((res) => {
        if (res.success) {
          this.setSession(res.data);
        }
      })
    );
  }

  me(): Observable<ApiEnvelope<LoginResponse>> {
    return this.http.get<ApiEnvelope<LoginResponse>>(`${this.apiUrl}/auth/me`);
  }

  logout(): void {
    sessionStorage.removeItem(SESSION_KEY);
    this.sessionSubject.next(null);
  }

  isLoggedIn(): boolean {
    return !!this.sessionSubject.value;
  }

  getToken(): string | null {
    return this.sessionSubject.value?.accessToken ?? null;
  }

  getSession(): LoginResponse | null {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as LoginResponse) : null;
  }

  private setSession(session: LoginResponse): void {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    this.sessionSubject.next(session);
  }
}
